import DetailRAP from './DetailRAP'

export default DetailRAP